/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途.
 */
import { Aggregator } from '@/models/GenerateCondit/Interrelated';
import { crudRequestGet, crudRequest } from '@/services/api';
import { getData_Vehicle2 } from '@/components/report/service';
import { getVolume } from '@/utils';
import moment from 'moment';

export default {
  namespace: 'unLoadingTableNew',
  state: {
    unLoadingList: [], // 在卸
  },

  effects: {
    *getUnloadindData(_, { put, select }) {
      const siteType = { scanSiteCode: true, nextSiteCode: true, preSiteCode: true };
      const dateFormat = 'YYYY-MM-DD HH:mm:ss';
      const {
        dateRange: date,
        centerFilter,
        actualArrivalCarsItem,
      } = yield select(({ vehicleMonitoringNew }) => vehicleMonitoringNew);
      async function getUnloadData(taskNoArr) {
        const andFilters = {
          scanSiteCode: centerFilter.code,
          scanSite: centerFilter.name,
          scanType: '分拨卸车',
          isOriginCenter: '否',
        };
        const inFilters = { taskNo: taskNoArr };
        const query = {
          dataSource: 'actual_load_unload_result',
          simpleGranularity: 'all',
          startDate: moment(date[0]).add(-1, 'days').format(dateFormat),
          endDate: date[1] && moment(date[1]).format(dateFormat),
          aggregators: [
            new Aggregator('longMin', 'unloadScanTime', '__time'),
            new Aggregator('doubleSum', 'goodsWeight', 'calcWeight'),
          ],
          dimensions: ['taskNo', 'preSite', 'deliveryReceiptNo', 'trackLine'],
          inFilters: inFilters
            ? Object.entries(inFilters).map(([key, value]) => ({ key, value }))
            : [],
          andFilters: andFilters
            ? Object.entries(andFilters).map(([key, value]) => {
                if (centerFilter?.code && siteType[key]) return { key, value: centerFilter.code };
                return { key, value };
              })
            : [],
        };
        const data = await getData_Vehicle2(query, {}, 'druid2');
        if (data?.length > 0) {
          return data;
        }
        return [];
      }

      async function getLoad(taskNoArr) {
        const andFilters = { scanType: '分拨装车', nextSiteCode: '$center' };
        const inFilters = { taskNo: taskNoArr };
        const startDate = moment(date[0]).add(-10, 'days').format(dateFormat);
        const query = {
          dataSource: 'actual_load_unload_result',
          simpleGranularity: 'all',
          startDate: startDate,
          endDate: date[1] && moment(date[1]).format(dateFormat),
          aggregators: [
            {
              type: 'doubleSum',
              name: 'goodsWeight',
              fieldName: 'calcWeight',
            },
          ],
          dimensions: ['taskNo', 'scanSite', 'deliveryReceiptNo'],
          andFilters: andFilters
            ? Object.entries(andFilters).map(([key, value]) => {
                if (centerFilter?.code && siteType[key]) return { key, value: centerFilter.code };
                return { key, value };
              })
            : [],
          inFilters: inFilters
            ? Object.entries(inFilters).map(([key, value]) => ({ key, value }))
            : [],
        };
        const data = await getData_Vehicle2(query, {}, 'druid2');
        if (data?.length > 0) {
          return data;
        }
        return [];
      }

      /** 已到达车辆 */
      let arrivalCarData = [...actualArrivalCarsItem];
      const taskNoArr = arrivalCarData.map((item) => item.taskNo);
      /** 已卸 */
      const unloadData = yield getUnloadData(taskNoArr);
      /** 装车,上一站到本站 字段带有s后缀 */
      const loadData = yield getLoad(taskNoArr);

      const suffix = 's';
      /**  unLoadingData 装/卸交接单匹配的数据集,从卸车数据中筛出交接单号匹配的装车数据进行拼接 */
      // let unLoadingData = unloadData.sort((a, b) => a.unloadScanTime - b.unloadScanTime)
      //   .map(unload => {
      //     const load = loadData.find(m => m.deliveryReceiptNo === unload.deliveryReceiptNo)
      //     // if (!load) return
      //     return {
      //       ...unload,
      //       [`ticket${suffix}`]: load.ticket,
      //       [`piece${suffix}`]: load.piece,
      //       [`goodsWeight${suffix}`]: load.goodsWeight,
      //       [`goodsVolume${suffix}`]: load.goodsVolume,
      //       deliveryReceiptNo: load.deliveryReceiptNo,
      //       siteName: unload.preSite,
      //     }
      //   }).filter(m => !!m)

      const deliveryReceiptNoArr = []; // 装车数据的交接单号集

      // 从匹配装车数据和卸车数据, 获取卸车内容
      let LoadingData = loadData
        .map((load) => {
          const unload = unloadData.find((m) => m.deliveryReceiptNo === load.deliveryReceiptNo);
          // deliveryReceiptNoArr.push(load.deliveryReceiptNo);
          if (!load) return null;
          return {
            ...unload,
            goodsWeight: Number(unload?.goodsWeight) || 0,
            [`ticket${suffix}`]: Number(load?.ticket),
            [`piece${suffix}`]: load?.piece,
            [`goodsWeight${suffix}`]: (Number(load?.goodsWeight) || 0) * 1,
            [`goodsVolume${suffix}`]: (Number(load?.goodsVolume) || 0) * 1,
            deliveryReceiptNo: load?.deliveryReceiptNo,
            siteName: unload?.preSite || load?.scanSite,
            taskNo: load?.taskNo,
          };
        })
        .filter((m) => !!m);
      console.log(
        '装车组装数据',
        LoadingData.map((e) => e.goodsWeight),
      );
      //#region ************************
      //  查询出装车货量和卸车货量;从(上一站到本站)装车数据中获取交接单号,批量查询交接单信息,
      //  卸车信息里包含卸车开始时间 unloadScanTime,交接单信息里包含卸车结束时间arriveEndTime
      //  有卸车开始没有结束就是在卸
      let unloadingList = [];
      for (let i = 0; i < arrivalCarData.length; i++) {
        const arrival = arrivalCarData[i];
        let temp = null;
        LoadingData = LoadingData.filter((loading) => {
          const isEq = loading.taskNo === arrival.taskNo;
          if (isEq) {
            const siteName = loading.siteName?.replace('分拨中心', '');
            deliveryReceiptNoArr.push(loading.deliveryReceiptNo);
            if (!temp) {
              const carTypeName = arrival.carTypeName?.replace('米', '');
              // 拼接车辆信息,货物信息,装卸重量
              temp = {
                key: i,
                ...arrival,
                ...loading,
                siteName,
                toTalVolume: getVolume[carTypeName],
                deliveryReceiptNo: [loading.deliveryReceiptNo],
                // arriveStartTime: moment(unloading.unloadScanTime)
                //   .utc()
                //   .format('YYYY-MM-DD HH:mm:ss'),
                goodsWeight: (loading?.goodsWeight || 0) * 1,
                goodsWeights: (loading?.goodsWeights || 0) * 1,
              };
            } else {
              temp.siteName += ',' + siteName;
              temp.deliveryReceiptNo.push(loading.deliveryReceiptNo);
              temp.goodsWeight += (loading?.goodsWeight || 0) * 1;
              temp.goodsWeights += (loading?.goodsWeights || 0) * 1;
            }
            if (temp.goodsWeights) {
            }
          }
          return !isEq; // 筛除已经匹配上了的
        });
        if (temp) unloadingList.push(temp);
        temp = null;
      }
      //#region 获取交接单信息,分批查询, preeCount设置批次条数,交接单长度20字符,注意不要大于GET请求长度限制
      const deliveryData = []; // 保存交接单信息集合
      const preeCount = 40; // 每次请求交接单信息条数
      for (let first = 0; first < deliveryReceiptNoArr.length; first += preeCount) {
        let last = first + preeCount;
        if (last > deliveryReceiptNoArr.length) last = deliveryReceiptNoArr.length;
        const deliverList = deliveryReceiptNoArr.slice(first, last);
        const result = yield crudRequestGet(
          // 获取交接单信息集
          `/api/v1/track/receipt/infoDetail?deliveryNoList=${deliverList.toString()}`,
          { module: 'maxcenterbusi' },
        );
        if (result && result?.data.length > 0) {
          deliveryData.push(...result?.data);
        }
      }
      //#endregion
      if (deliveryData.length > 0) {
        // 根据交接单信息,得到卸车结束时间,
        unloadingList = unloadingList.filter((unLoading) => {
          // 一趟车多交接单情况(单运输凭单号多交接单号),任意一个交接单没有卸车结束视为整车未结束
          for (let i = 0; i < unLoading?.deliveryReceiptNo.length; i++) {
            const deliveryReceiptNo = unLoading.deliveryReceiptNo[i];
            const findDeliveryInfo = deliveryData.find(
              (delivery) => delivery.deliveryReceitpNo === deliveryReceiptNo,
            );
            if (
              (!unLoading.arriveStartTime && findDeliveryInfo?.arriveBeginTime) ||
              (unLoading.arriveStartTime &&
                findDeliveryInfo?.arriveBeginTime &&
                moment(unLoading.arriveStartTime).isAfter(
                  moment(findDeliveryInfo?.arriveBeginTime),
                ))
            ) {
              // 根据交接单设置卸车开始时间
              unLoading.arriveStartTime = findDeliveryInfo.arriveBeginTime;
              unLoading.arriveStartTimeUTC = moment(findDeliveryInfo.arriveBeginTime).utc();
            }
            if (!unLoading.trackLine) {
              unLoading.trackLine = findDeliveryInfo?.carProperty?.trackLineName || '';
            }

            // 有开始卸车时间,没有卸车结束时间,就是在卸
            if (
              findDeliveryInfo?.arriveBeginTime &&
              (!findDeliveryInfo || !findDeliveryInfo.arriveEndTime)
            )
              return true;
            // 交接单`i`未结束,本条数据为`在卸`
            else continue; // 第`i`交接单个已结束,继续匹配下一个
          }
          return false; // 全部卸车结束
        });
      } else {
        unloadingList = [];
      }
      // 获取在卸 PDA 状态
      let site = yield select(({ vehicleMonitoringNew }) => vehicleMonitoringNew?.centerFilter);
      const resData = yield crudRequest(`/api/route/selectUnLoadPDA`, {
        siteName: site?.name,
        siteCode: site?.code,
        taskNos: unloadingList?.map((item) => item.taskNo),
      });
      if (resData?.code === 1) {
        let PDAStatus = {};
        resData?.data?.forEach((item) => {
          PDAStatus[item.taskNo] = item;
        });
        unloadingList?.forEach((item) => {
          item.pdaStatus = PDAStatus?.[item.taskNo]?.pdaStatus;
        });
      }
      // 获取在装 PDA 状态 结束
      yield put({ type: 'updateState', payload: { unLoadingList: unloadingList } });
      //#endregion
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
